import aiphotoeditingtoolLinks from './config/aiphotoeditingtool';

const utils = {
  aiphotoeditingtool: [
    aiphotoeditingtoolLinks.photoEnhance,
    aiphotoeditingtoolLinks.photoColorize,
    aiphotoeditingtoolLinks.objectRemoval,
    aiphotoeditingtoolLinks.removeBackground,
    aiphotoeditingtoolLinks.blurBackground,
    aiphotoeditingtoolLinks.changeBackground,
    aiphotoeditingtoolLinks.aiLighting,
    aiphotoeditingtoolLinks.aiImageExtender,
    aiphotoeditingtoolLinks.aiReplace,
    aiphotoeditingtoolLinks.viewalltools,
  ],
  genai: [
    aiphotoeditingtoolLinks.aiavatar,
    aiphotoeditingtoolLinks.textimage,
    aiphotoeditingtoolLinks.aihairstyle,
    aiphotoeditingtoolLinks.aiHeadshot,
    aiphotoeditingtoolLinks.makeTransfer,
    aiphotoeditingtoolLinks.viewalltools,
    // aiphotoeditingtoolLinks.aihairstyles,
    // aiphotoeditingtoolLinks.aifashion,
  ],
  consumerApps: ['ymk', /*'y4b',*/ 'ycp', 'yca', 'yce', 'ycv', 'ycn'],
};

export default utils;
